import { uuidv4 } from "@microsoft/omnichannel-chat-sdk";
export const customerUser = {
  id: "usedId",
  name: "User",
  role: "user"
};
export const botUser = {
  id: "botId",
  name: "Bot",
  role: "bot"
};

// WebChat expects an "echo" activity to confirm the message has been sent successfully
export const postEchoActivity = function (activityObserver, activity, user) {
  let delay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
  const echoActivity = {
    ...activity,
    id: uuidv4(),
    from: {
      ...activity.from,
      ...user
    },
    timestamp: new Date().toISOString()
  };
  setTimeout(() => {
    activityObserver === null || activityObserver === void 0 ? void 0 : activityObserver.next(echoActivity); // mock message sent activity
  }, delay);
};
export const postBotMessageActivity = function (activityObserver, text) {
  let tags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  let delay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
  setTimeout(() => {
    activityObserver === null || activityObserver === void 0 ? void 0 : activityObserver.next({
      id: uuidv4(),
      from: {
        ...botUser
      },
      text,
      type: "message",
      channelData: {
        tags
      },
      timestamp: new Date().toISOString()
    });
  }, delay);
};
export const postSystemMessageActivity = function (activityObserver, text) {
  let delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
  postBotMessageActivity(activityObserver, text, "system", delay);
};
export const postBotTypingActivity = function (activityObserver) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  setTimeout(() => {
    activityObserver === null || activityObserver === void 0 ? void 0 : activityObserver.next({
      id: uuidv4(),
      from: {
        ...botUser
      },
      type: "typing"
    });
  }, delay);
};
export const postBotAttachmentActivity = function (activityObserver) {
  let attachments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
  setTimeout(() => {
    activityObserver === null || activityObserver === void 0 ? void 0 : activityObserver.next({
      id: uuidv4(),
      from: {
        ...botUser
      },
      attachments,
      type: "message",
      timestamp: new Date().toISOString()
    });
  }, delay);
};